import React from 'react';
import { AppBar, Box, Toolbar } from '@mui/material';

import { Link } from 'react-router-dom';
import NavigationOptionsIconButton from '../../../components/Headers/NavigationOptionsIconButton';
import { getAppLogoUrl } from '../../../helper';

const HeaderBar: React.FC = () => {
  return (
    <Box flexGrow={1}>
      <AppBar
        elevation={0}
        position="static"
        color="inherit"
        sx={{ backgroundColor: 'transparent' }}
      >
        <Toolbar>
          <NavigationOptionsIconButton iconStyles={{ color: '#ffffff' }} />
          <Box component={Link} to={`${process.env.PUBLIC_URL}/`}>
            <img
              src={getAppLogoUrl('tp-logo-text-white.png')}
              alt="tp-logo"
              style={{ width: '120px' }}
            />
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default HeaderBar;
